import axios, { AxiosResponse } from 'axios'
import { getAppBaseUrl } from './api'

const baseURL = getAppBaseUrl()

export interface EcsuiteCardRecoveryFilters {
    days: number
    domain: string
    status: string
    page: number
    page_size: number
}

export const getEcsuiteCardRecoveryQueue = (filters: EcsuiteCardRecoveryFilters): Promise<AxiosResponse> => {
    const url = `${baseURL}/sticky-io/card-recovery`
    return axios.get(url, { params: filters })
}

export const previewEcsuiteCardRecoveryEmails = (filters: Pick<EcsuiteCardRecoveryFilters, 'days' | 'domain'>): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/sticky-io/card-recovery/email-preview`, filters)
}

export const sendEcsuiteCardRecoveryEmail = (request: { days: number, domain: string, recovery_reference: string }): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/sticky-io/card-recovery/send-email`, request)
}

export const sendAllEcsuiteCardRecoveryEmails = (request: { days: number, domain: string, expected_ready_count: number }): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/sticky-io/card-recovery/send-all`, {
        ...request,
        confirmation: 'SEND REFRESH EMAILS'
    })
}

export const getEcsuiteCardRecoveryEmailBatch = (batchId: string): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/sticky-io/card-recovery/email-batch/${batchId}`)
}
